import React, { PropsWithChildren } from "react";
import Button from "./shared/button";
import { SvgHelp } from "./svg";

export const ProgressBar: React.FC<PropsWithChildren> = ({ children }) => {
  let step = 0;
  const map = (c: React.ReactNode): React.ReactNode => {
    const component = c as React.ReactElement | null;
    if (!component) {
      return null;
    }

    if ((component.type as any)?.name !== ProgressBarItem.name) {
      if (!(component as any).props?.children) {
        return component;
      }
      return React.cloneElement(component as any, {
        children: React.Children.map((component as any).props.children, map),
      });
    }

    step++;

    return React.cloneElement(component as any, {
      stepNumber: step,
      key: (component as any).props.title,
    });
  };

  return <>{React.Children.map(children, map)}</>;
};

export const ProgressBarItem: React.FC<
  PropsWithChildren<{
    stepNumber?: number;
    title: string | React.ReactNode;
    isOpen?: boolean;
    helpText?: string;
    lastItem?: boolean;
  }>
> = ({ children, stepNumber, title, isOpen, helpText, lastItem }) => {
  if (isOpen) {
    return (
      <group data-wrap="no" data-name="progress_bar" data-direction="column">
        <group data-wrap="no" data-gap="20" data-width="auto">
          <group data-direction="column" data-width="auto">
            <group
              data-background="accent-dark"
              data-length="30"
              data-height="30"
              data-color="white"
              data-align="center"
              data-justify="center"
              data-text-size="13"
              data-weight="700"
              data-radius="40"
              data-shrink="no"
            >
              {stepNumber}
            </group>
            <group
              data-direction="column"
              data-wrap="no"
              data-length="30"
              data-gap="1"
              data-contain=""
              data-height="autofit"
            >
              {!lastItem && (
                <group
                  data-background="accent-dark"
                  data-length="2"
                  data-height="autofit"
                  data-position="center"
                ></group>
              )}
            </group>
          </group>

          <group data-align="center" data-width="auto">
            <group data-name="progress_bar_title" data-gap="10">
              <group data-gap="10" data-align="center">
                <text
                  data-weight="400"
                  data-text-size="22"
                  data-ellipsis=""
                  data-color="grey-color-dark"
                >
                  {title}
                </text>
                {helpText && (
                  <>
                    <Button
                      micro
                      rounded
                      toggleClassName="open"
                      material
                      text=""
                      data-shrink="no"
                      data-help=""
                      //textFirst={true}
                    >
                      <icon data-help="">
                        {" "}
                        <SvgHelp />{" "}
                      </icon>{" "}
                    </Button>
                    <group data-name="help_text">
                      <text
                        data-wrap="wrap"
                        data-weight="400"
                        data-text-size="12"
                        data-ellipsis=""
                        data-color="grey-color-dark"
                      >
                        {helpText}
                      </text>
                    </group>
                  </>
                )}
              </group>
            </group>
          </group>
        </group>
        <group data-wrap="no" data-gap="20">
          {!lastItem && (
            <group
              data-direction="column"
              data-wrap="no"
              data-length="30"
              data-gap="1"
              data-contain=""
            >
              <group
                data-background="accent-dark"
                data-length="2"
                data-height="autofit"
                data-position="center"
              ></group>
            </group>
          )}
          <group
            data-length="autofit"
            data-space-bottom="50"
            data-space-top="20"
          >
            {children}
          </group>
        </group>
      </group>
    );
  }

  return (
    <group data-wrap="no" data-name="progress_bar" data-direction="column">
      <group>
        <group
          data-wrap="no"
          data-gap="20"
          data-width="auto"
          data-name="progress_bar_header"
        >
          <group
            data-name="progress_bar_point"
            data-background="grey-color-mid"
            data-length="30"
            data-height="30"
            data-color="white"
            data-align="center"
            data-justify="center"
            data-text-size="13"
            data-weight="700"
            data-radius="40"
            data-shrink="no"
          >
            {stepNumber}
          </group>
          <group
            data-align="center"
            data-width="auto"
            data-name="progress_bar_title"
          >
            <text
              data-weight="400"
              data-text-size="22"
              data-ellipsis=""
              data-color="grey-color-mid"
            >
              {title}
            </text>
          </group>
        </group>
      </group>
      <group data-wrap="no" data-gap="20">
        <group
          data-direction="column"
          data-wrap="no"
          data-length="30"
          data-gap="1"
          data-contain=""
        >
          {/*<group data-background="accent-dark" data-length="2" data-height="autofit" data-position="center"></group>*/}
        </group>
        <group
          data-length="autofit"
          //data-space-bottom="50"
          data-space-top="20"
        ></group>
      </group>
    </group>
  );
};
